
import { useEffect, useState } from "react";
import AddCommand from "../AddCommand";

const commandColor = '#55efc4';

// Has params: props.id, props.comps, props.setComps, props.indices, props.setIsScriptRendered, props.childrenArray
export default function LoopRangeCommand(props) {

    const [evaluatedErrors, setEvaluatedErrors] = useState(false);
    const [color, setColor] = useState(commandColor);

    const [isAddingCommand, setIsAddingCommand] = useState(false);

    if (!evaluatedErrors) {
        if (props.childrenArray[0].length === 1) {
            setColor(commandColor);
            setEvaluatedErrors(true);
        } else {
            setColor('#FC427B');
            setEvaluatedErrors(true);
        }
    }

    let variable = "";
    let begin = 1;
    let end = 1;
    let prefix = '';
    let suffix = '';
    let comment = -1;
    let thisObj = props.comps[props.id].script[props.indices[0]];
    for (let k = 0; k < props.indices.length - 1; ++k) {
        thisObj = thisObj.children[props.indices[k + 1]];
    }

    try {
        variable = thisObj.var;
        comment = thisObj.comment;
        begin = thisObj.begin;
        end = thisObj.end;
        prefix = thisObj.prefix;
        suffix = thisObj.suffix;
    } catch (e) {

    }

    let vars_to_options = [<option value="">None</option>];
    for (let k = 0; k < props.vars.length; ++k) {
        vars_to_options.push(<option value={props.vars[k].name}>
            {props.vars[k].name}
        </option>);
    }

    useEffect(() => {
        if (props.childrenArray[0].length === 1) {
            setColor(commandColor);
            setEvaluatedErrors(true);
        } else {
            setColor('#FC427B');
            setEvaluatedErrors(true);
        }
    });

    return <>
        <div style={{
            marginBottom: '2vmax',
            display: 'inline-block',
            marginRight: '4vmax',
            verticalAlign: 'top'
        }}>
            <div style={{
                padding: '1vmax',
                backgroundColor: color,
                color: '#000',
                display: 'inline-block',
                fontSize: '1.15vmax',
                fontFamily: "Work Sans, Lato, sans-serif",
                fontWeight: '500'
            }}>
                LOOP
            </div>
            <a className='panel-button' style={{
                padding: '1vmax',
                display: 'inline-block',
                fontSize: '1.15vmax',
                fontFamily: "Work Sans, Lato, sans-serif",
                fontWeight: '300',
                border: '0pt',
                borderLeft: `1pt solid #faf3dd`,
                marginLeft: '1vmax'
            }} onClick={(e) => {
                e.preventDefault();
                let new_comps = [...props.comps];
                let thisObj = new_comps[props.id].script[props.indices[0]];
                for (let k = 0; k < props.indices.length - 2; ++k) {
                    thisObj = thisObj.children[props.indices[k + 1]];
                } thisObj.children.splice(props.indices[props.indices.length - 1], 1);
                props.setComps(new_comps);
                props.setIsScriptRendered(false);
            }}>
                Delete
            </a>
            <i className='fa fa-solid fa-comment-dots pointy comp' style={{
                padding: '1vmax',
                display: 'inline-block',
                fontSize: '1.15vmax',
                fontWeight: '300',
                border: '0pt',
                borderLeft: `1pt solid #faf3dd`,
                marginLeft: '1vmax',
                backgroundColor: comment === -1 ? "#000" : "#faf3dd",
                color: comment === -1 ? "#faf3dd" : "#000"
            }} onClick={(e) => {
                e.preventDefault();
                let new_comps = [...props.comps];
                let thisObj = new_comps[props.id].script[props.indices[0]];
                for (let k = 0; k < props.indices.length - 1; ++k) {
                    thisObj = thisObj.children[props.indices[k + 1]];
                }
                if (thisObj.comment !== -1) {
                    thisObj.comment = -1;
                } else {
                    thisObj.comment = "Comments";
                }
                props.setComps(new_comps);
                props.setIsScriptRendered(false);
            }}></i>

            {/* Copy Command Icon */}
            <i className='fa fa-solid fa-copy pointy comp panel-button' style={{
                padding: '1vmax',
                display: 'inline-block',
                fontSize: '1.15vmax',
                fontWeight: '300',
                border: '0pt',
                borderLeft: `1pt solid #faf3dd`,
                marginLeft: '1vmax'
            }} onClick={(e) => {
                e.preventDefault();
                let thisObj = props.comps[props.id].script[props.indices[0]];
                for (let k = 0; k < props.indices.length - 1; ++k) {
                    thisObj = thisObj.children[props.indices[k + 1]];
                }
                navigator.clipboard.writeText(JSON.stringify(thisObj));
            }}></i>

            <div style={{
                padding: '2vmax 0',
                borderLeft: `3pt solid ${color}`,
                borderBottom: `1pt dashed ${color}`,
                paddingLeft: '2vmax',
                fontFamily: "Work Sans, Lato, sans-serif",
                fontWeight: '500',
                paddingRight: '2vmax'
            }} className='code-block'>
                <div style={{
                    display: 'inline-block',
                    fontSize: '1.15vmax',
                    marginBottom: props.childrenArray[0].length === 1 ? '1vmax' : '0vmax'
                }}>RANGE <select className='panel-dropdown' onChange={(e) => {
                    e.preventDefault();
                    if (e.target.value !== '') {
                        let new_comps = [...props.comps];
                        let thisObj = new_comps[props.id].script[props.indices[0]];
                        for (let k = 0; k < props.indices.length - 1; ++k) {
                            thisObj = thisObj.children[props.indices[k + 1]];
                        } thisObj.var = e.target.value;
                        props.setComps(new_comps);
                        props.setIsScriptRendered(false);
                    }
                }} value={variable} style={{
                    marginLeft: '0.5vmax',
                    marginRight: '0.5vmax',
                    maxWidth: '5vmax'
                }}>
                        {vars_to_options}
                    </select> FROM <input type='number' style={{
                        fontWeight: '300',
                        fontSize: '1.15vmax',
                        marginLeft: '0.5vmax',
                        padding: '0.5vmax',
                        maxWidth: '5vmax'
                    }} className='panel-input' value={begin} onChange={(e) => {
                        let new_comps = [...props.comps];
                        let thisObj = new_comps[props.id].script[props.indices[0]];
                        for (let k = 0; k < props.indices.length - 1; ++k) {
                            thisObj = thisObj.children[props.indices[k + 1]];
                        } thisObj.begin = e.target.value;
                        props.setComps(new_comps);
                        props.setIsScriptRendered(false);
                    }}></input> TO <input type='number' style={{
                        fontWeight: '300',
                        fontSize: '1.15vmax',
                        marginLeft: '0.5vmax',
                        padding: '0.5vmax',
                        maxWidth: '5vmax'
                    }} className='panel-input' value={end} onChange={(e) => {
                        let new_comps = [...props.comps];
                        let thisObj = new_comps[props.id].script[props.indices[0]];
                        for (let k = 0; k < props.indices.length - 1; ++k) {
                            thisObj = thisObj.children[props.indices[k + 1]];
                        } thisObj.end = e.target.value;
                        props.setComps(new_comps);
                        props.setIsScriptRendered(false);
                    }}></input></div>
                {props.childrenArray[0].length === 1 ? <div style={{
                    marginLeft: '0vmax'
                }}>{props.childrenArray[0]}</div> : <><br /><br /><br /><i className='fa fa-solid fa-plus panel-icon' style={{
                    fontSize: '1vmax',
                    padding: '0.5vmax',
                    borderRadius: '100px',
                    marginLeft: '3.5vmax',
                    marginBottom: '2vmax'
                }} onClick={(e) => {
                    e.preventDefault();
                    setIsAddingCommand('0');
                }} /></>} <br />

                <div style={{
                    display: 'inline-block',
                    fontSize: '1.15vmax',
                    marginBottom: props.childrenArray[0].length === 1 ? '1vmax' : '0vmax'
                }}>PREFIX: <input style={{
                    fontWeight: '300',
                    fontSize: '1.15vmax',
                    marginLeft: '0.5vmax',
                    padding: '0.5vmax',
                    maxWidth: '5vmax'
                }} className='panel-input' value={prefix} onChange={(e) => {
                    let new_comps = [...props.comps];
                    let thisObj = new_comps[props.id].script[props.indices[0]];
                    for (let k = 0; k < props.indices.length - 1; ++k) {
                        thisObj = thisObj.children[props.indices[k + 1]];
                    } thisObj.prefix = e.target.value;
                    props.setComps(new_comps);
                    props.setIsScriptRendered(false);
                }}></input>, SUFFIX: <input style={{
                    fontWeight: '300',
                    fontSize: '1.15vmax',
                    marginLeft: '0.5vmax',
                    padding: '0.5vmax',
                    maxWidth: '5vmax'
                }} className='panel-input' value={suffix} onChange={(e) => {
                    let new_comps = [...props.comps];
                    let thisObj = new_comps[props.id].script[props.indices[0]];
                    for (let k = 0; k < props.indices.length - 1; ++k) {
                        thisObj = thisObj.children[props.indices[k + 1]];
                    } thisObj.suffix = e.target.value;
                    props.setComps(new_comps);
                    props.setIsScriptRendered(false);
                }}></input></div>

                {
                    comment === -1 ? <></> : <>
                        <input className='panel-input-reverse' style={{
                            width: '100%',
                            height: '2vmax',
                            marginTop: '1vmax'
                        }} value={comment} onChange={(e) => {
                            let new_comps = [...props.comps];
                            let thisObj = new_comps[props.id].script[props.indices[0]];
                            for (let k = 0; k < props.indices.length - 1; ++k) {
                                thisObj = thisObj.children[props.indices[k + 1]];
                            }
                            thisObj.comment = e.target.value;
                            props.setComps(new_comps);
                            props.setIsScriptRendered(false);
                        }}></input>
                    </>
                }
            </div>
        </div>
        {/* <br/> */}
        {
            isAddingCommand === '0' ? <AddCommand id={props.id} comps={props.comps}
                setComps={props.setComps} indices={[...props.indices].concat([0])}
                setIsScriptRendered={props.setIsScriptRendered}
                setIsAddingCommand={setIsAddingCommand}
                availableCommands={[
                    "conditional/if",
                    "loop/range",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "variable/set" : "variable/table/set",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "variable/setFrom" : "",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "signal/error" : "signal/table/error",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "flags/set" : "",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "flags/setToChild" : "",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "" : "signal/table/disableRow",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "signal/disable" : "signal/table/disable",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "signal/enable" : "signal/table/enable",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "signal/warning" : "signal/table/warning",
                    props.comps[props.id].type !== "intermediate/InputTable" ? "signal/disableSelf" : "",
                    'signal/setRecordName',
                ]} /> : <></>
        }
    </>;

}